import { render, staticRenderFns } from "./ChatWedget.vue?vue&type=template&id=ef4beeba&"
import script from "./ChatWedget.vue?vue&type=script&lang=js&"
export * from "./ChatWedget.vue?vue&type=script&lang=js&"
import style0 from "./ChatWedget.vue?vue&type=style&index=0&id=ef4beeba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports